module.exports = __webpack_public_path__ + "img/layer3.91789bdd.png";